import React from "react";
import { getAppealSubject } from "../../utils/appealSubject";
import "./AppealSubjectDetails.css";

function DetailRow({ label, value }) {
  if (!value || value === "—") return null;
  return (
    <div className="appeal-subject-row">
      <span className="appeal-subject-label">{label}</span>
      <span className="appeal-subject-value">{value}</span>
    </div>
  );
}

export default function AppealSubjectDetails({
  appeal,
  penalties = [],
  variant = "card",
}) {
  const subject = getAppealSubject(appeal, penalties);
  if (!subject) return null;

  if (variant === "compact") {
    return (
      <div className="appeal-subject-compact">
        <div className="appeal-subject-kind">{subject.typeLabel}</div>
        {subject.dateLabel ? (
          <div className="appeal-subject-date">يوم الواقعة: {subject.dateLabel}</div>
        ) : null}
        {subject.whatHappened ? (
          <div className="appeal-subject-what" title={subject.whatHappened}>
            {subject.whatHappened}
          </div>
        ) : null}
        {subject.daysLabel && subject.daysLabel !== "—" ? (
          <div className="appeal-subject-meta">الخصم: {subject.daysLabel}</div>
        ) : null}
        {subject.amountLabel ? (
          <div className="appeal-subject-meta">{subject.amountLabel}</div>
        ) : null}
      </div>
    );
  }

  return (
    <div className="appeal-subject-box">
      <h4 className="appeal-subject-title">تفاصيل الواقعة المتظلَّم عليها</h4>
      <DetailRow label="الموضوع" value={subject.typeLabel} />
      <DetailRow label="يوم الواقعة" value={subject.dateLabel} />
      {subject.dateToLabel ? (
        <DetailRow label="إلى" value={subject.dateToLabel} />
      ) : null}
      <DetailRow label="اللي حصل" value={subject.whatHappened} />
      <DetailRow
        label="قيمة الخصم"
        value={
          subject.daysLabel && subject.daysLabel !== "—"
            ? subject.daysLabel
            : subject.amountLabel
        }
      />
      {subject.daysLabel &&
      subject.daysLabel !== "—" &&
      subject.amountLabel ? (
        <DetailRow label="المبلغ" value={subject.amountLabel} />
      ) : null}
    </div>
  );
}
